<template>
  <error-layout :session="session">
    <div class="mt-12 sm:mt-0 px-4 py-5 flex flex-col items-center justify-center w-full">
      <div class="min-w-0 flex-1 h-full max-w-sm mx-auto  px-4 select-none ">

        <horizontal-divider></horizontal-divider>
        <h1 class="text-3xl sm:text-4xl font-extralight">{{ message }}</h1>
        <horizontal-divider></horizontal-divider>
      </div>
    </div>
  </error-layout>
</template>

<script>
import ErrorLayout from '@/Pages/DiyWorkshop/Shared/ErrorLayout';
import HorizontalDivider from '@/Shared/HorizontalDivider';

export default {
  components: {
    ErrorLayout,
    HorizontalDivider,
  },

  props: {
    session: {
      type: Object,
      required: false,
    },

    message: {
      type: String,
      default: 'Es ist ein Fehler aufgetreten.',
    },
  },
};
</script>